import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import AnimatedLogo from "@/branding/AnimatedLogo";
import { brand } from "@/branding";

const SplashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate("/login"), 2600);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      data-testid="page-splash"
      className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[#0B0B0C]"
    >
      {/* Halo lime en arrière-plan */}
      <motion.div
        aria-hidden
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      >
        <div className="h-[520px] w-[520px] rounded-full bg-[#C8FF2F]/12 blur-3xl" />
      </motion.div>

      {/* Grille subtile */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.035] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(#FFFFFF 1px, transparent 1px), linear-gradient(90deg, #FFFFFF 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative z-10 flex flex-col items-center gap-10 px-6">
        <AnimatedLogo size={140} showWordmark={true} wordColor="#FFFFFF" testId="splash-logo" />

        <motion.div
          className="flex flex-col items-center gap-4 max-w-sm text-center"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.5, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p
            data-testid="splash-slogan"
            className="text-[13px] text-white/80 font-medium tracking-wide"
          >
            {brand.slogan}
          </p>
          <div className="flex items-center gap-1.5" aria-hidden>
            <motion.span
              className="h-1.5 w-1.5 rounded-full bg-[#C8FF2F]"
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut", delay: 0 }}
            />
            <motion.span
              className="h-1.5 w-1.5 rounded-full bg-[#C8FF2F]"
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
            />
            <motion.span
              className="h-1.5 w-1.5 rounded-full bg-[#C8FF2F]"
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
            />
          </div>
          <p
            data-testid="splash-text"
            className="text-[12px] text-white/50 tracking-wide"
          >
            Préparation de votre espace…
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default SplashScreen;
